//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from '../Components/Component';
import MButton from '../Components/Controls/Button';
import {HomeIconName} from '../Icons';
import WithRouterProps from '../WithRouterProps';
import withRouter from '../WithRouter';
import TemplateOne from '../Templates/TemplateOne';

//endregion

/** */
type Props = WithRouterProps & {};

/** */
class AccessDeniedPage extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.bindMethods();
    }

    /** */
    private bindMethods(): void {
        this.homeButton_onClick = this.homeButton_onClick.bind(this);
    }

    /** */
    private homeButton_onClick(): void {
        this.props.navigate('/');
    }

    /** */
    public render(): ReactElement {

        return (
            <TemplateOne title="Access Denied"
                         message="You do not have permission to access the request resource.">

                <MButton label="Home"
                         icon={HomeIconName}
                         disabled={false}
                         onClick={this.homeButton_onClick}/>

            </TemplateOne>
        );

    }

}

export default withRouter(AccessDeniedPage);
